import { createSelector } from 'reselect';
import { requestApi } from '../../../services/api.js';
import {
	REDUCER_NAME,
	ACTION_PREFIX,
	HIGHLIGHT_GAMES_BASE_URL,
	BET_AMOUNT_TAXATION_RULE_TYPE,
	WIN_OVER_LIMIT_TAXATION_RULE_TYPE
} from '../highlight-games-constants.js';

// Constants
const DEFAULT_INFO_POLLING_TIME = 5000;
const DEFAULT_HISTORY_POLLING_TIME = 10000;

// Actions
const FETCH_CONFIGURATION_REQUESTED = `${ACTION_PREFIX}/FETCH_CONFIGURATION_REQUESTED`;
const FETCH_CONFIGURATION_SUCCEEDED = `${ACTION_PREFIX}/FETCH_CONFIGURATION_SUCCEEDED`;
const FETCH_CONFIGURATION_FAILED = `${ACTION_PREFIX}/FETCH_CONFIGURATION_FAILED`;

// Selectors
export const selectVideoPlayerScriptUrl = state => state[REDUCER_NAME].configuration.videoPlayerScriptUrl;
export const selectVideoRtmpUrl = state => state[REDUCER_NAME].configuration.videoRtmpUrl;
export const selectVideoRtmpStreamName = state => state[REDUCER_NAME].configuration.videoRtmpStreamName;
export const selectVideoWebsocketUrl = state => state[REDUCER_NAME].configuration.videoWebsocketUrl;
export const selectVideoProgressiveUrl = state => state[REDUCER_NAME].configuration.videoProgressiveUrl;
export const selectVideoHlsUrl = state => state[REDUCER_NAME].configuration.videoHlsUrl;
export const selectPollingTime = state => state[REDUCER_NAME].configuration.pollingTime;
export const selectHistoryPollingTime = state => state[REDUCER_NAME].configuration.historyPollingTime;
export const selectTaxationRules = state => state[REDUCER_NAME].configuration.taxationRules;
export const selectBetAmountTaxationRule = createSelector([selectTaxationRules], taxationRules => {
	return taxationRules.find(taxationRule => taxationRule.type === BET_AMOUNT_TAXATION_RULE_TYPE);
});
export const selectWinOverLimitTaxationRule = createSelector([selectTaxationRules], taxationRules => {
	return taxationRules.find(taxationRule => taxationRule.type === WIN_OVER_LIMIT_TAXATION_RULE_TYPE);
});

// Action creators
export const fetchConfiguration = () => async dispatch => {
	dispatch({ type: FETCH_CONFIGURATION_REQUESTED });
	try {
		const response = await requestApi(`${HIGHLIGHT_GAMES_BASE_URL}/configuration`);

		if (response.error) {
			dispatch({ type: FETCH_CONFIGURATION_FAILED });
		}

		dispatch({
			type: FETCH_CONFIGURATION_SUCCEEDED,
			payload: {
				videoPlayerScriptUrl: response.videoPlayerScriptUrl,
				videoRtmpUrl: response.videoRtmpUrl,
				videoRtmpStreamName: response.videoRtmpStreamName,
				videoWebsocketUrl: response.videoWebsocketUrl,
				videoProgressiveUrl: response.videoProgressiveUrl,
				videoHlsUrl: response.videoHlsUrl,
				pollingTime: response.pollingTime,
				historyPollingTime: response.historyPollingTime,
				taxationRules: response.taxationRules
			}
		});
	} catch (error) {
		dispatch({ type: FETCH_CONFIGURATION_FAILED });
		throw new Error(error);
	}
};

// Reducer
const initialState = {
	videoPlayerScriptUrl: undefined,
	videoRtmpUrl: undefined,
	videoRtmpStreamName: undefined,
	videoWebsocketUrl: undefined,
	videoProgressiveUrl: undefined,
	videoHlsUrl: undefined,
	pollingTime: DEFAULT_INFO_POLLING_TIME,
	historyPollingTime: DEFAULT_HISTORY_POLLING_TIME,
	taxationRules: undefined
};

// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
	switch (type) {
		case FETCH_CONFIGURATION_SUCCEEDED:
			return {
				...state,
				videoPlayerScriptUrl: payload.videoPlayerScriptUrl,
				videoRtmpUrl: payload.videoRtmpUrl,
				videoRtmpStreamName: payload.videoRtmpStreamName,
				videoWebsocketUrl: payload.videoWebsocketUrl,
				videoProgressiveUrl: payload.videoProgressiveUrl,
				videoHlsUrl: payload.videoHlsUrl,
				pollingTime: payload.pollingTime,
				historyPollingTime: payload.historyPollingTime,
				taxationRules: payload.taxationRules
			};
		default:
			return state;
	}
};
